var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.86 56.23h-2.63V43.783C13.184 40.46 2.686 32.915 2.686 27.654V26.46h2.152v1.195c0 2.953 5.907 8.692 15.054 14.647l.49.31V53.96l3.826-2.87v-8.37l.49-.31c9.147-5.979 15.053-11.694 15.053-14.647v-1.196h2.153v1.196c0 5.26-10.498 12.805-15.544 16.13v8.369l-5.5 3.97z",
    fill: "#191E21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.025 27.534h-19.13v-2.152h19.13a.12.12 0 00.12-.12v-2.391a.12.12 0 00-.12-.12H2.57a.12.12 0 00-.12.12v2.391a.12.12 0 00.12.12h9.565v2.152H2.569a2.272 2.272 0 01-2.272-2.272v-2.391a2.272 2.272 0 012.272-2.272h39.456a2.272 2.272 0 012.272 2.272v2.391a2.272 2.272 0 01-2.272 2.272zM41.904 19.284h-2.152v-3.706h-3.707v-2.153h5.859v5.86z",
    fill: "#191E21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.122 19.284H34.97V7.208h-2.63v4.902h-2.152V5.056h6.934v14.228z",
    fill: "#191E21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.34 19.284h-2.152v-6.098h-2.63v6.098h-2.152v-8.25h6.934v8.25zM6.14 19.704L1.012 7.592 18.922 0l7.09 2.87 2.248 5.296-1.985.837-1.889-4.471-5.44-2.2L3.833 8.727l4.292 10.14-1.984.836z",
    fill: "#191E21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.591 8.548l-1.817-4.292 1.985-.85.968 2.32 2.32-.98.837 1.973-4.293 1.83z",
    fill: "#191E21"
  })));
}
export default SvgGroup8;